import clsx from "clsx"

import { TruncatableText } from "@particles/index"

import styles from "./ListItemCaption.module.scss"
import { ListItemCaptionProps } from "./ListItemCaption.types"

export default function ListItemCaption(props: ListItemCaptionProps) {
    const { caption, prefixSlot, suffixSlot, truncate = true, state = "default" } = props

    return (
        <div className={clsx(styles.base, styles[`${state}State`])}>
            {prefixSlot}
            {truncate ? (
                <TruncatableText text={caption} tooltipOnTruncate={true} className={styles.caption} />
            ) : (
                <span className={styles.caption}>{caption}</span>
            )}
            {suffixSlot}
        </div>
    )
}
